
import { ToastInfo } from '../dist/types'
import { defineComponent, getCurrentInstance } from 'vue'

export default defineComponent({
    name: "bc-toast",
    props: {
        time: { type: Number, default: 5000 }
    },
    data() {
        return {
            list: getCurrentInstance()?.appContext
                .config.globalProperties.$bcui['bc-toast'].toastList as ToastInfo[],
            remove: getCurrentInstance()?.appContext
                .config.globalProperties.$bcui['bc-toast'].remove
        }
    },
    mounted() {
        // 初始化显示时间设置
        getCurrentInstance()?.appContext
            .config.globalProperties.$bcui['bc-toast']
            .setShowTime(this.time)
    }
})
